<script lang="ts">
	import { isLocalhostOrE2e } from '../mode';
	import type { LayoutData } from './$types';
	import ServiceUnavailable from '$components/error/ServiceUnavailable.svelte';
	import Sandbox from '$components/sandbox/Sandbox.svelte';
	import { onMount } from 'svelte';

	export let data: LayoutData;

	onMount(() => {
		// eslint-disable-next-line no-undef
		const elementsToDisplay = document.getElementsByClassName('opacity') as HTMLCollectionOf<HTMLElement>;

		[...elementsToDisplay].forEach(
			(element) => {
				element.style.opacity = '1';
			}
		);

	});
</script>

{#if data.toggles.showUpHome?.enabled}
	{#if isLocalhostOrE2e()}
		<div class="local-page-container">
			{#if !data.isASheet}
				<Sandbox testUsers="{data.testUsers}" />
			{/if}
			<slot></slot>
		</div>
	{:else}
		<slot></slot>
	{/if}
{:else}
	<ServiceUnavailable />
{/if}


<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .local-page-container {
    background-color: tokens.$oc-base-color-gray-25;
  }

</style>
